import type { SceneVisualKey } from "@/assets/v2/manifest";

export type V2Scene = "intro" | "question" | "first" | "struggle" | "dedication" | "reflection" | "theory" | "jiaxing" | "action" | "ticket" | "lights" | "end";

export type ViewportProfile = "mobile" | "tablet" | "desktop";

export const sceneOrder: V2Scene[] = ["intro", "question", "first", "struggle", "dedication", "reflection", "theory", "jiaxing", "action", "ticket", "lights", "end"];

export const sceneVisualKey: Record<V2Scene, SceneVisualKey> = {
  intro: "intro", question: "question", first: "first", struggle: "struggle", dedication: "dedication",
  reflection: "reflection", theory: "theory", jiaxing: "jiaxing", action: "action", ticket: "ticket",
  lights: "lights", end: "end",
};

export const sceneLabel: Record<V2Scene, string> = {
  intro: "南湖 · 雾中靠岸", question: "把问题交给红船", first: "首创 · 离岸", struggle: "奋斗 · 湖心",
  dedication: "奉献 · 穿雾", reflection: "回望 · 水面静止", theory: "坐标 · 红船精神", jiaxing: "嘉兴 · 时代长卷",
  action: "下一站 · 青年行动", ticket: "红船青年船票 · 已启航", lights: "LIGHTS", end: "END",
};
